import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllSupplierApi,
  GetBranchSupplierApi,
  GetCompanyAPI,
} from "../../ApiRequests";

export const fetchSuppliers = createAsyncThunk("fetch/Suppliers", async () => {
  try {
    const response = await GetCompanyAPI();
    return response?.data?.data.payload;
  } catch (error) {
    console.log(error);
  }
  return [];
});
// export const  = createAsyncThunk("fetch-items", async () => {});

const SupplierSlice = createSlice({
  name: "suppliers",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSuppliers.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchSuppliers.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchSuppliers.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default SupplierSlice.reducer;
